// types.js


export const FETCH_RESULT = 'FETCH_RESULT'
export const FETCH_VER = 'FETCH_VER'
export const FETCH_LAST_VER = 'FETCH_LAST_VER'
export const FETCH_LAST_VER_REFRESH = 'FETCH_LAST_VER_REFRESH'

export const TIMER_TICK = 'TIMER_TICK'
export const TICK = 'TICK'
export const START_TIMER = 'START_TIMER'
export const STOP_TIMER = 'STOP_TIMER'
export const TOGGLE_SERIES = 'TOGGLE_SERIES'
export const UNTOGGLE_SERIES = 'UNTOGGLE_SERIES'

export const SET_FILTER_SERIES = 'SET_FILTER_SERIES'
export const SET_FILTER_SEURA = 'SET_FILTER_SEURA'
export const SET_FILTER_LAHTO = 'SET_FILTER_LAHTO'
export const SET_FILTER_SIJA = 'SET_FILTER_SIJA'
export const SET_FILTER_MAALI = 'SET_FILTER_MAALI'
export const SET_FILTER_ERO = 'SET_FILTER_ERO'
export const SET_FILTER_HAKU = 'SET_FILTER_HAKU'
export const SET_FILTER_KERRAT = 'SET_FILTER_KERRAT'

export const SORT_MAALI = 'SORT_MAALI'
export const SORT_SARJA = 'SORT_SARJA'
